import { render, staticRenderFns } from "./QuanLyMatKhau.vue?vue&type=template&id=7a1eba66&"
import script from "./QuanLyMatKhau.vue?vue&type=script&lang=js&"
export * from "./QuanLyMatKhau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports